import { render, staticRenderFns } from "./CobrancaInfo.vue?vue&type=template&id=1b73ee1d"
import script from "./CobrancaInfo.vue?vue&type=script&lang=js"
export * from "./CobrancaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports